import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const HideIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-hide', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M14.5333 8.4L14.8333 8H13.1333C12.36 8.88667 10.3133 10.9333 8 10.9333C5.68667 10.9333 3.64001 8.88667 2.86667 8H1.16667L1.46667 8.4C1.97766 9.05043 2.55155 9.64889 3.18 10.1867L2.14001 11.3333L3.12667 12.2267L4.24667 10.98C4.71316 11.2917 5.20882 11.5574 5.72667 11.7733L5.12 13.2467L6.35334 13.7533L7.02 12.1533C7.34258 12.2206 7.67058 12.2586 8 12.2667C8.34051 12.2652 8.68 12.2295 9.01334 12.16L9.68001 13.8L10.9067 13.2867L10.28 11.7733C10.7711 11.5688 11.2421 11.3188 11.6867 11.0267L12.74 12.1867L13.7267 11.2933L12.76 10.22C13.4133 9.67718 14.0077 9.06716 14.5333 8.4Z' />
    </svg>
  );
};

export default HideIcon;
